'use client'
import { atom } from 'jotai'
import { useHydrateAtoms } from 'jotai/utils'
import type { ReactNode } from 'react'
import { type ProductPageData } from '@/components/ProductPage/getProductPageData'

const productPageDataAtom = atom<ProductPageData | null>(null)

type Props = {
  children: ReactNode
  productPageData: ProductPageData
}

export function ProductPageDataProvider({ children, productPageData }: Props) {
  useSyncProductPageData(productPageData)
  return children
}

const useSyncProductPageData = (productPageData: ProductPageData) => {
  useHydrateAtoms([[productPageDataAtom, productPageData]])
}
